import { render, staticRenderFns } from "./Step03ContentItems.vue?vue&type=template&id=7fed008e"
import script from "./Step03ContentItems.vue?vue&type=script&lang=js"
export * from "./Step03ContentItems.vue?vue&type=script&lang=js"
import style0 from "./Step03ContentItems.vue?vue&type=style&index=0&id=7fed008e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports